"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREDECESSOR_FIELD_LABEL = exports.cancelledOrderOptionsSchema = exports.cancelledOrderOptionSchema = exports.matchPredecessorPreviewSchema = exports.matchPredecessorOrderIdsSchema = exports.MAX_PICKED_PREDECESSOR_ORDERS = void 0;
exports.predecessorNotFoundMessage = predecessorNotFoundMessage;
exports.predecessorNotCancelledMessage = predecessorNotCancelledMessage;
exports.replacesCancelledOrderLine = replacesCancelledOrderLine;
const zod_1 = require("zod");
// The predecessor reference: the cancelled order a replacement order replaces.
// One order can replace more than one, because released tickets from two
// different cancelled orders can be matched into a single new order.
//
// The reference is recorded on the replacement order and points backwards. It
// is never written onto a ticket: the tickets carry the lineage only through
// their link rows on the cancelled order, and the reference is derived from
// those at match time.
/** An order id, as it travels on the wire: a positive integer in a string. */
const orderIdStringSchema = zod_1.z.string().regex(/^\d+$/, 'must be a positive integer order id');
// The hand-pick is capped at two so a direct call cannot record an unbounded
// list: a single-pair match carries one buy and one sell ticket, and two is the
// most that could need naming by hand. The derived references carry no cap —
// a multi-line match can legitimately draw on more tickets than that.
exports.MAX_PICKED_PREDECESSOR_ORDERS = 2;
/**
 * The hand-picked predecessors on a match request. Sent only when no selected
 * ticket resolves one of its own — the derived references always win, and a
 * pick that repeats one of them is absorbed rather than duplicated.
 */
exports.matchPredecessorOrderIdsSchema = zod_1.z
    .array(orderIdStringSchema)
    .max(exports.MAX_PICKED_PREDECESSOR_ORDERS)
    .optional();
/** The auto-fill the match screen reads before the order exists. */
exports.matchPredecessorPreviewSchema = zod_1.z.object({
    predecessorOrderIds: zod_1.z.array(zod_1.z.string()),
});
/** One row of the hand-pick list: a cancelled order the user can choose. */
exports.cancelledOrderOptionSchema = zod_1.z.object({
    id: zod_1.z.string(),
    supplierName: zod_1.z.string().nullable(),
    buyerName: zod_1.z.string().nullable(),
    commodity: zod_1.z.string().nullable(),
    quantityMt: zod_1.z.string().nullable(),
    cancelledAt: zod_1.z.string().nullable(),
});
exports.cancelledOrderOptionsSchema = zod_1.z.object({
    candidates: zod_1.z.array(exports.cancelledOrderOptionSchema),
});
// Refusals for a hand-picked predecessor that does not name a cancelled order.
// Both are reached only by a direct call: the picker offers cancelled orders
// alone, so a real click can produce neither. Wording proposed, not owner-signed.
function predecessorNotFoundMessage(orderId) {
    return `Order ${orderId} was not found and cannot be recorded as a predecessor.`;
}
function predecessorNotCancelledMessage(orderId) {
    return `Order ${orderId} is not cancelled and cannot be recorded as a predecessor.`;
}
// The label the replacement order and the match screen use for the reference.
// Proposed wording, carried through from the flow's own words for what the user
// sees; the mount point on the order page is still an open craft item.
exports.PREDECESSOR_FIELD_LABEL = 'Replaces cancelled order';
function replacesCancelledOrderLine(orderId) {
    return `Replaces cancelled order ${orderId}`;
}
//# sourceMappingURL=order-predecessor.js.map